import { PaymentClientNonce } from '../../../models/Payment/PaymentClientNonce.js';

class Braintree {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(currency) {
    return this.apiClient.get('com/payment-gateway/nonce', currency ? {
      currency
    } : undefined).then(response => PaymentClientNonce.createFromResponse(response.data));
  }
}

export { Braintree };
//# sourceMappingURL=Braintree.js.map
